import { Injectable } from '@angular/core';
import { HttpService } from "./http.service";
import { CreateResult } from "../models/create-result";
import { CustomTagsParticipantLinkViewModel } from "../models/custom-tags-participant-link";
import { CustomTagViewModel } from '../models/custom-tag';
import { debug } from 'util';
import { CustomTagsTerminalViewModel } from '../models/custom-tag-terminal-view-model';
import { TerminalParamViewModel } from '../models/terminal-param-view-model';
import { TerminalGroupsViewModel } from '../models/terminal-groups';
import { TerminalGroupsByParticipantLinkViewModel } from '../models/terminal-groups-participant-link';
import { TerminalGroupViewModel } from '../models/terminal-group-view-model';
import { TaParamsFilesViewModel } from '../models/ta-params-files-view-model';

@Injectable({
  providedIn: 'root'
})
export class CustomTagService {


  constructor(private _httpService: HttpService) {
  }

  public async GetCustomParamByParticipantId(): Promise<CustomTagsParticipantLinkViewModel[]> {

    const httpResult = await this._httpService.apiGet<CustomTagsParticipantLinkViewModel[]>(`customTag/GetCustomParamByParticipantId`);
    if (httpResult && httpResult.body) {
      return (<any>httpResult.body);
    }
    return [];
  }

  public async GetCustomParamByTerminalId(terminalId: string): Promise<TerminalParamViewModel[]> {

    const httpResult = await this._httpService.apiGet<TerminalParamViewModel[]>(`customTag/GetCustomParamByTerminalId/${terminalId}`);
    if (httpResult && httpResult.body) {
      return (<any>httpResult.body);
    }
    return [];
  }

  public async GetCustomTagsByParticipantId(id: number): Promise<CustomTagsParticipantLinkViewModel[]> {

    const httpResult = await this._httpService.apiGet<CustomTagsParticipantLinkViewModel[]>(`customTag/GetCustomTagsByParticipantId/${id}`);
    if (httpResult && httpResult.body) {
      return (<any>httpResult.body);
    }
    return [];
  }

  public async GetCustomTagsByParticipantIdTerminalConfigId(participantId: number, terminalConfigId: number): Promise<CustomTagsParticipantLinkViewModel[]> {
    const httpResult = await this._httpService.apiGet<CustomTagsParticipantLinkViewModel[]>(`customTag/GetCustomTagsByParticipantIdTerminalConfigId/${participantId}/${terminalConfigId}`);
    if (httpResult && httpResult.body) {
      return (<any>httpResult.body);
    }
    return [];
  }

  public async GetCustomTagsByParticipantIdTerminalConfigIdGroupName(participantId: number, terminalConfigId: number, groupName: string): Promise<CustomTagsParticipantLinkViewModel[]> {
    const httpResult = await this._httpService.apiGet<CustomTagsParticipantLinkViewModel[]>(`customTag/GetCustomTagsByParticipantIdTerminalConfigIdGroupName/${participantId}/${terminalConfigId}/${groupName}`);
    if (httpResult && httpResult.body) {
      return (<any>httpResult.body);
    }
    return [];
  }

  public async GetCustomTagsByTerminalID(terminalId: string, group: string, participantId: number, terminalConfigId: number): Promise<CustomTagsParticipantLinkViewModel[]> {
    const httpResult = await this._httpService.apiGet<CustomTagsParticipantLinkViewModel[]>(`customTag/GetCustomTagsByTerminalID/${terminalId}/${group}/${participantId}/${terminalConfigId}`);
    if (httpResult && httpResult.body) {
      return (<any>httpResult.body);
    }
    return [];
  }


  public async GetGroupsByParticipantIdTerminalConfigId(participantId: number, terminalConfigId: number): Promise<TerminalGroupsByParticipantLinkViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalGroupsByParticipantLinkViewModel[]>(`customTag/GetTerminalGroupsByParticipantIdTerminalConfigId/${participantId}/${terminalConfigId}`);
    if (httpResult && httpResult.body) {
      return (<any>httpResult.body);
    }
    return [];
  }

  public async GetGroupByParticipantIdTerminalConfigIdGroupName(participantId: number, terminalConfigId: number, groupName: string): Promise<TerminalGroupsByParticipantLinkViewModel> {
    const httpResult = await this._httpService.apiGet<TerminalGroupsByParticipantLinkViewModel>(`customTag/GetGroupByParticipantIdTerminalConfigIdGroupName/${participantId}/${terminalConfigId}/${groupName}`);
    if (httpResult && httpResult.body) {
      return (<any>httpResult.body);
    }
    return;
  }


  public async GetRTTerminalGroupsByTerminalId(terminalId: string): Promise<TerminalGroupViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalGroupViewModel[]>(`customTag/GetRTTerminalGroupsByTerminalId/${terminalId}`);
    if (httpResult && httpResult.body) {
      return (<any>httpResult.body);
    }
    return [];
  }

  public async GetCustomTags(): Promise<CustomTagViewModel[]> {
    const httpResult = await this._httpService.apiGet<CustomTagViewModel[]>(`customTag/GetAllCustomTags`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetTaParamFiles(): Promise<TaParamsFilesViewModel[]> {
    const httpResult = await this._httpService.apiGet<TaParamsFilesViewModel[]>(`customTag/GetTaParamsFiles`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }


  public async GetTerminalGroups(): Promise<TerminalGroupsViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalGroupsViewModel[]>(`customTag/GetAllTerminalGroups`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async AddUpdateCustomTags(customTags: CustomTagsParticipantLinkViewModel[], terminalId: string): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPut<CreateResult>(`customTag/AddUpdateCustomTags/${terminalId}`, customTags);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async UpdateCustomTags(customTags: CustomTagsParticipantLinkViewModel[]): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPut<CreateResult>(`customTag/UpdateCustomTags`, customTags);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async AddCustomParameter(customTags: CustomTagsParticipantLinkViewModel): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPut<CreateResult>(`customTag/AddCustomParameter`, customTags);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async GetCustomParameterType(customTags: string): Promise<Boolean> {

    const httpResult = await this._httpService.apiPut<Boolean>(`customTag/GetCustomParameterType`, customTags);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async DeleteCustomParameter(customTags: CustomTagsParticipantLinkViewModel): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPut<CreateResult>(`customTag/DeleteCustomParameter`, customTags);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }
  public async UpdateRTCustomParameter(customTags: string, value: string, terminalId: string ): Promise<CreateResult> {

    const httpResult = await this._httpService.apiGet<CreateResult>(`customTag/UpdateRTCustomParameter/${customTags}/${value}/${terminalId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async UpdateLDCustomParameter(customTags: CustomTagsParticipantLinkViewModel): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPut<CreateResult>(`customTag/UpdateLDCustomParameter`, customTags);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }


  public async UpdateCustomParameter(customTags: CustomTagsParticipantLinkViewModel): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPut<CreateResult>(`customTag/UpdateCustomParameter`, customTags);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async UpdateDefaultValueByRecordId(customTags: CustomTagsParticipantLinkViewModel): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPut<CreateResult>(`customTag/UpdateDefaultValueByRecordId`, customTags);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async UpdateTerminalGroup(customTags: TerminalGroupsByParticipantLinkViewModel[]): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPut<CreateResult>(`customTag/UpdateTerminalGroup`, customTags);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }


  public async AddTerminalGroup(customTags: TerminalGroupsByParticipantLinkViewModel): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPut<CreateResult>(`customTag/AddTerminalGroup`, customTags);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async setCustomParamEditable(customTags: TerminalGroupsByParticipantLinkViewModel): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPut<CreateResult>(`customTag/setCustomParamEditable`, customTags);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async DeleteTerminalGroup(customTags: TerminalGroupsByParticipantLinkViewModel): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPut<CreateResult>(`customTag/DeleteTerminalGroup`, customTags);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }


  public async SaveTerminalGroupCustomParameters(customTags: TerminalGroupViewModel[], terminalId: string, terminalConfigId: number): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPut<CreateResult>(`customTag/SaveTerminalGroupCustomParameters/${terminalId}/${terminalConfigId}`, customTags);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }


  public async AddTerminalGroupCustomParameters(customTags: TerminalGroupViewModel, terminalId: string, terminalConfigId: number): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPut<CreateResult>(`customTag/AddTerminalGroupCustomParameters/${terminalId}/${terminalConfigId}`, customTags);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async DeleteCustomTagsByParticipantId(id: number): Promise<CreateResult> {

    const httpResult = await this._httpService.apiGet<CreateResult>(`customTag/DeleteCustomTags/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;

    } return { message: "An unknown error occured", success: false };
  }

  public async DeleteCustomTagsByParticipantIdAndTerminalConfig(participantId: number, terminalConfigId: number): Promise<CreateResult> {

    const httpResult = await this._httpService.apiGet<CreateResult>(`customTag/DeleteCustomTagsByParticipantIdTerminalConfig/${participantId}/${terminalConfigId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;

    } return { message: "An unknown error occured", success: false };
  }

  public async DeleteTerminalGroupByParticipantIdAndTerminalConfig(participantId: number, terminalConfigId: number): Promise<CreateResult> {

    const httpResult = await this._httpService.apiGet<CreateResult>(`customTag/DeleteTerminalGroupByParticipantIdAndTerminalConfig/${participantId}/${terminalConfigId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;

    } return { message: "An unknown error occured", success: false };
  }

  public async DeleteCustomTagsByParticipantIdAndTerminalConfigGroupName(participantId: number, terminalConfigId: number, groupName: string ): Promise<CreateResult> {

    const httpResult = await this._httpService.apiGet<CreateResult>(`customTag/DeleteCustomTagsByParticipantIdTerminalConfigGroupName/${participantId}/${terminalConfigId}/${groupName}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;

    } return { message: "An unknown error occured", success: false };
  }

  public async GetTerminalsCountByCustomTags(customTag: string, participantId: number): Promise<CustomTagsTerminalViewModel[]> {
    const httpResult = await this._httpService.apiGet<CustomTagsTerminalViewModel[]>(`customTag/GetTerminalsByCustomTag/${customTag}/${participantId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async DeleteTerminalGroupByTerminalIdGroupName(terminalId: string, groupName: string, terminalConfigId: number ): Promise<CreateResult> {

    const httpResult = await this._httpService.apiGet<CreateResult>(`customTag/DeleteTerminalGroupByTerminalIdGroupName/${terminalId}/${groupName}/${terminalConfigId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;

    } return { message: "An unknown error occured", success: false };
  }

}
